module.exports = __webpack_public_path__ + "img/elite-plus.b2ee7083.svg";